import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { RequestFinanceEntryResponse } from "@/types";

async function createFinanceEntry(
  request: FormData
): Promise<RequestFinanceEntryResponse> {
  const response = await httpRequest.post<RequestFinanceEntryResponse>(
    `/finance-entries`,
    request,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export function useCreateFinanceEntryMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createFinanceEntry,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["finance-entries"] });
    },
  });
}
